/* Föderation form modal — aligned 1:1 to .design-ref/pim-admin/index.html */

.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.stackSm {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--form-gap);
  align-items: end;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
}

.fld {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fldLabel {
  font-size: var(--font-size-s);
  font-weight: 400;
  color: var(--color-grey);
}

.fldHint {
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}

.divider {
  height: 1px;
  background: var(--color-grey-lightest);
  margin: 4px 0;
}

.mono input {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-s);
}

/* secret-box: input + regenerate button on one row */
.secretBox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.secretBox > :first-child {
  flex: 1;
  min-width: 0;
}

/* chip multi-select (response types): DS Chip inside a bare toggle button */
.fchips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.chipBtn {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

/* custom-id-claims editor rows */
.claimRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.claimRow > :nth-child(2) {
  flex: 1;
  min-width: 0;
}

.claimIcon {
  flex-shrink: 0;
  color: var(--color-grey-light);
  display: inline-flex;
}

.addBtn {
  align-self: flex-start;
  margin-top: 2px;
}

/* modal footer: hint left, actions right */
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.footHint {
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}

.footActions {
  display: flex;
  gap: 8px;
}
